
import { ReducerBase } from "common/reducer";
import initialState from "app/initialState";
import { FuturesContractPriceUpdated } from "./futuresContracts.actions";
import FuturesContractPrice from "./futuresContractPrice";
import { BySymbol } from "app/IAppStore";

export class FuturesContractPriceReducer extends ReducerBase<BySymbol<FuturesContractPrice>> {
    constructor() {
        super();
        this.addHandler(FuturesContractPriceUpdated.EventName, this.handleFuturesContractPriceUpdated);
    }

    handleFuturesContractPriceUpdated(state: BySymbol<FuturesContractPrice> = initialState.futuresContractPrices, event: FuturesContractPriceUpdated): BySymbol<FuturesContractPrice> {
        
        //Check timestamp so we don't overwrite realtime snapshots with delayed streaming prices
        const needsUpdate = state[event.contract.symbol] == null || state[event.contract.symbol].priceUpdated < event.contract.priceDateTime ||
            event.contract.isSettled || event.contract.isTradingHalted;

        if (!needsUpdate) return state;

        return {
            ...state,
            [event.contract.symbol]: {
                ...event.contract,
                priceUpdated: event.contract.priceDateTime
            }
        }
    }

    handleDefault(state: BySymbol<FuturesContractPrice> = initialState.futuresContractPrices) {
        return state;
    }
}
